<template>
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card p-shadow-1">
                <h5>Solicitações</h5>
                <hr />
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-3">                        
                        <div class="p-formgroup-inline">
                            <div class="p-field-radiobutton">
                                <RadioButton v-model="tipoFiltro" name="tipoFiltro" value="FILTRAR_PENDENTES" @change="listar"/>
                                <label>Pendentes</label>
                            </div>
                            <div class="p-field-radiobutton">
                                <RadioButton v-model="tipoFiltro" name="tipoFiltro" value="FILTRAR_PERIODO" @change="listar"/>
                                <label>Período</label>
                            </div>                           
                        </div>
                    </div>
                </div>
                <DataTable :value="solicitacoes" :filters="filtro" :paginator="true" :rows="10" responsiveLayout="scroll"
					paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
					:rowsPerPageOptions="[10,20,30,50]" currentPageReportTemplate="Listando {first} a {last} de {totalRecords}"
					class="p-datatable-sm p-datatable-striped">        
                    <template #header v-if="tipoFiltro == 'FILTRAR_PERIODO'">
						<div class="table-header">			
							<div class="p-d-flex p-jc-between">	
                                <Calendar v-model="mesAno" view="month" dateFormat="mm/yy" 
                                    :showIcon="true" :manualInput="false" :yearNavigator="true" 
                                    :yearRange="rangeData" :locale="localeCalendarBR" 
                                    @date-select="listarPorPeriodo"/>
                                <span class="p-input-icon-left">
                                    <i class="pi pi-search" />
                                    <InputText v-model="filtro['global']" placeholder="Filtrar..." />
                                </span>
							</div>
                            
						</div>
					</template>       
                    <Column field="data" header="Data da Solicitação"></Column>
                    <Column field="dataPonto" header="Data do Ponto"></Column>
                    <Column field="tipo" header="Tipo da Solicitação"></Column>
                    <Column field="status" header="Status">
                        <template #body="slotProps">
                            <span class="p-text-bold" :class="aplicarBadgeStatus(slotProps.data.status)">
                                {{ slotProps.data.status }}
                            </span>
                        </template>
                    </Column>
                </DataTable>
            </div>
            
        </div>        
    </div>
</template>

<script>
import PontoService from '@/service/PontoService';
import { mapGetters } from "vuex";
import { localeCalendarBR, exibirMensagem } from "@/global";

export default {   
    pontoService: null,
    data() {
        return {
            tipoFiltro: 'FILTRAR_PENDENTES',
            mesAno: new Date(),
            rangeData: "",
            localeCalendarBR: localeCalendarBR,
            solicitacoes: [],          
            filtro: {}          
        };
    },
    methods: {
        ...mapGetters('sessao', ['getUsuario', 'limparSessao']),      
        /**
         *
         */
        listar() {
            if(this.tipoFiltro == 'FILTRAR_PERIODO') {
                this.mesAno = new Date();
                this.listarPorPeriodo();
            } else if(this.tipoFiltro == 'FILTRAR_PENDENTES') {                
                this.listarPendentes();
            }                     
        },
        /**
         *
         */
         listarPorPeriodo() { 
            this.solicitacoes = [];             
            let requisicao = {
                id: this.getUsuario().id,
                grupo: this.getUsuario().grupo,
                mes: this.mesAno.getMonth() + 1,
                ano: this.mesAno.getFullYear(),
                tipoDispositivo: 'Web'
            }
            this.pontoService.solicitacoes(requisicao)
            .then((resp) => {
                resp.data.forEach((sol) => {                    
                    sol.data = this.formartarStrData(sol.data);
                    sol.dataPonto = this.formartarStrData(sol.dataPonto);                       
                    this.solicitacoes.push(sol);
                });
            })
            .catch((erro) => {
                if(erro.response.status == 401) {
                    this.logout();
                } else {
                    exibirMensagem(this, erro)
                }
            });
        },
        /**
         *
         */
         listarPendentes() { 
            this.solicitacoes = [];             
            let requisicao = {
                id: this.getUsuario().id,
                grupo: this.getUsuario().grupo,              
                tipoDispositivo: 'Web'
            }
            this.pontoService.solicitacoesPendentes(requisicao)
            .then((resp) => {
                resp.data.forEach((sol) => {                    
                    sol.data = this.formartarStrData(sol.data);
                    sol.dataPonto = this.formartarStrData(sol.dataPonto);                       
                    this.solicitacoes.push(sol);
                });
            })
            .catch((erro) => {
                if(erro.response.status == 401) {
                    this.logout();
                } else {
                    exibirMensagem(this, erro)
                }
            });
        },  
        /**
         *     
         */
        formartarStrData(strData) {
            let partes = strData.split("-");
            return partes[2] + "/" + partes[1] + "/" + partes[0];
        },  
        /**
         *
         * @param {*} status
         */
         aplicarBadgeStatus(status) {
            let badge = "ik-badge-success";
            if (status == "Pendente") {
                badge = "ik-badge-warnning";
            } else if (status == "Não Aprovado") {
                badge = "ik-badge-danger";
            }
            return badge;
        },     
        /**
         *
         */
        criarRangeData() {
            let anoAtual = new Date().getFullYear();     
            this.rangeData = (anoAtual-40)+':'+(anoAtual+1);
        },
        /**
         * 
         */
         logout() {
          this.limparSessao();			
          this.$router.push('/login');
        } 
    },
    created() {
        this.pontoService = new PontoService();
        this.listar();
    },
    mounted() {
        this.criarRangeData();       
    },
};
</script>
<style scoped>
</style>